










































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import http from "@/axios/http-common";

@Component({
  components: {},
})
export default class AutoCompleteDiagnosa extends Vue {
  @Prop() dokterDefault: object;
  @Prop() unit_id: string;
  @Prop() length: number;
  @Prop() index: number;
  @Prop() autofocus: boolean;
  @Prop() disabled: boolean;
  @Prop() diagnosa = {
    kode: null,
    nama: null,
    kasus: null,
    tgl: null,
    unit_id: null,
    dr_id: null,
  };
  listDiagnosa = [];
  searchString = null;
  _timerId;

  removeItem() {
    this.$emit("removeItem");
  }
  addDiag() {
    this.$emit("addDiag");
  }
  changeDiagnosa(val) {
    if (val) {
      console.log("val", val);
      this.diagnosa.kode = val["value"];
      this.diagnosa.nama = val["label"];
      this.diagnosa.kasus = "";
      this.diagnosa.tgl = new Date().toISOString().substr(0, 10);
      this.diagnosa.unit_id = this.unit_id;
      this.diagnosa.dr_id = this.dokterDefault["id"];

      this.$emit("selectedItem", {
        diagnosa: this.diagnosa,
        index: this.index,
      });
    }
  }

  @Watch("searchString")
  searched() {
    this.listDiagnosa = [];
    clearTimeout(this._timerId);
    this._timerId = setTimeout(() => {
      if (this.searchString === null || this.searchString.length < 2) return;
      this.searchDiagnosa(this.searchString);
    }, 500);
  }
  searchDiagnosa(termSearch) {
    http
      .getDataParam(`/referensi/diagnosis-icd/search`, {
        params: { term: termSearch },
      })
      .then((res) => {
        this.listDiagnosa = res.data;
      })
      .finally();
  }
}
